import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const NotesPanel = ({ notes, isExpanded, onToggle }) => {
  return (
    <div className={`bg-gray-100 border-r border-gray-300 overflow-y-auto transition-all duration-300 ${isExpanded ? 'w-2/5' : 'w-12'}`}>
      {isExpanded ? (
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold text-gray-900">Patient Notes</h3>
            <button
              onClick={onToggle}
              className="text-gray-600 hover:text-gray-900 p-1"
              title="Minimize notes"
            >
              <ChevronLeft size={24} />
            </button>
          </div>
          <div className="bg-white p-4 rounded-lg border border-gray-300 mb-6">
            <p className="text-gray-700 whitespace-pre-wrap">{notes}</p>
          </div>
        </div>
      ) : (
        <div className="h-full flex flex-col items-center py-6">
          <button
            onClick={onToggle}
            className="text-gray-600 hover:text-gray-900 p-2 mb-4"
            title="Expand notes"
          >
            <ChevronRight size={24} />
          </button>
          <div className="transform rotate-90 whitespace-nowrap mt-8">
            <span className="text-sm font-semibold text-gray-600">Patient Notes</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotesPanel;

